import React from "react";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import BroadcastHandlers from "./BroadcastHandlers";
import {
  addReplyHandler,
  selectBroadcast,
  selectBroadcastReplyHandlers,
  setReplyHandlers,
} from "../store/slices/broadcastSlice";
import JsonCollapse from "../Builder/Components/JsonCollapse";

export default function ReplyHandlers() {
  const dispatch = useDispatch();
  const broadcast = useSelector(selectBroadcast);
  const replyHandlers = useSelector(selectBroadcastReplyHandlers);
  const comms = broadcast.Messages.map((message) => message.Channel);

  return (
    <div className="bg-purple-gradient p-3">
      <BroadcastHandlers
        handlers={replyHandlers}
        setHandlers={(newReplyHandlers) => {
          dispatch(setReplyHandlers(newReplyHandlers));
        }}
        comms={comms.join("-")}
      />
      <div
        className={`d-flex ${
          replyHandlers.length === 0
            ? "justify-content-center"
            : "justify-content-end"
        } `}
      >
        <button
          type="button"
          className="d-flex btn p-0 align-items-center gap-2 mb-3"
          onClick={() => {
            dispatch(addReplyHandler());
          }}
        >
          <FontAwesomeIcon
            icon={faPlus}
            className="bg-colored text-white p-2 rounded-pill "
          />
          <span
            className={`fw-bold ${replyHandlers.length === 0 ? "fs-5" : ""} `}
          >
            ADD REPLY HANDLER
          </span>
        </button>
      </div>
      <JsonCollapse json={replyHandlers} />
    </div>
  );
}
